import * as React from "react";

const MenuIcon = (props) => (
	<svg
		width={20}
		height={12}
		viewBox="0 0 20 12"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path
			d="M1 11h18M1 6h18M1 1h18"
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);
export default MenuIcon;
